const deliveryAddress = {
  addTitle: 'Add New Delivery Address',
  addSubtitle: 'Here you can add your delivery address.',
  editTitle: 'Edit Delivery Address',
  editSubtitle: 'Here you can edit your delivery address.',
  save: 'Save',
  update: 'Update',
  back: 'Back',
  editSuccess: 'Your delivery address has been successfully updated',
  addSuccess: 'Your new delivery address has been successfully saved',
  infoMessage: '{strongText}: We use the phone number only for potential inquiries from the pharmacy regarding your pre-orders. Additionally, you will be informed about the status of your order via SMS and email.',
  infoMessageTitle: 'Our Promise',
  fillNecessary: '* Please fill in the required fields',
}

export default deliveryAddress
